module.exports = __webpack_public_path__ + "img/Bank-Mayapada-Logo.d5a7283f.jpg";